(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerGroup = document.querySelector('.shopify-section-group-header-group');
      this.mobileSearchContainer = document.querySelector('.mobile-search-container');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        if (this.headerGroup) {
          this.headerGroup.classList.add('shopify-section-header-sticky');
        } else {
          this.header.classList.add('shopify-section-header-sticky');
        }
        this.setBodyPadding();
      }

      // Ensure header group is always sticky if it exists
      if (this.headerGroup) {
        this.headerGroup.style.position = 'sticky';
        this.headerGroup.style.top = '0';
        this.headerGroup.style.zIndex = '100';
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const headerHeight = this.header.offsetHeight;
      const headerGroupHeight = this.headerGroup ? this.headerGroup.offsetHeight : headerHeight;

      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      document.documentElement.style.setProperty('--header-group-height', `${headerGroupHeight}px`);

      // Update body padding for sticky headers
      if (
        this.headerIsAlwaysSticky ||
        (this.headerGroup && this.headerGroup.classList.contains('shopify-section-header-sticky'))
      ) {
        this.setBodyPadding();
      }
    }

    setBodyPadding() {
      const headerGroupHeight = this.headerGroup ? this.headerGroup.offsetHeight : this.header.offsetHeight;
      const mobileSearchContainer = document.querySelector('.mobile-search-container');
      const isMobileSearchVisible =
        mobileSearchContainer &&
        window.innerWidth <= 989 &&
        !mobileSearchContainer.classList.contains('mobile-search-hidden');
      const mobileSearchHeight = isMobileSearchVisible ? mobileSearchContainer.offsetHeight : 0;

      document.body.style.paddingTop = `${headerGroupHeight + mobileSearchHeight}px`;
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.headerGroup || this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Handle mobile search bar visibility - DISABLED to keep search bar always visible
      // this.handleMobileSearchVisibility(scrollTop);

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    // DISABLED: handleMobileSearchVisibility - keeping search bar always visible
    // handleMobileSearchVisibility(scrollTop) {
    //   if (!this.mobileSearchContainer || window.innerWidth > 989) return;

    //   const scrollThreshold = 10; // Hide search bar when scrolling down from top

    //   if (scrollTop > scrollThreshold) {
    //     // Hide mobile search when scrolling down
    //     this.mobileSearchContainer.classList.add('mobile-search-hidden');
    //   } else {
    //     // Show mobile search when at top
    //     this.mobileSearchContainer.classList.remove('mobile-search-hidden');
    //   }
    // }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      const targetElement = this.headerGroup || this.header;
      targetElement.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      const targetElement = this.headerGroup || this.header;
      targetElement.classList.add('shopify-section-header-sticky', 'animate');
      targetElement.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      const targetElement = this.headerGroup || this.header;
      targetElement.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
